// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import styles from './BulletList.styles.js';

class BulletList extends React.Component<Props> {

  constructor(props) {
    super(props);

    this.state = {
      src: '',
      style: {},
    };
  }

  render() {
    const {classes} = this.props;

    return (
      <ul className={classes.root}>
        {this.props.list && this.props.list.map(item => {
          return (
            <li key={item.id}>
              <Link to={`/${item.name}`}>{item.title}</Link>
            </li>
          )
        })
        }
      </ul>
    );
  }
}

const Component = withStyles(styles)(BulletList);
export {Component as BulletList};
export default Component;